import script from "./AutoAIAgentChat.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutoAIAgentChat.vue?vue&type=script&setup=true&lang=ts"

import "./AutoAIAgentChat.vue?vue&type=style&index=0&id=63007936&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63007936"]])

export default __exports__